import { render, staticRenderFns } from "./CustomerEditTreatments.vue?vue&type=template&id=c7c13534&scoped=true"
import script from "./CustomerEditTreatments.vue?vue&type=script&lang=js"
export * from "./CustomerEditTreatments.vue?vue&type=script&lang=js"
import style0 from "./CustomerEditTreatments.vue?vue&type=style&index=0&id=c7c13534&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c13534",
  null
  
)

export default component.exports